module.exports = __webpack_public_path__ + "img/kiosk-carrefour-estrie-home.a4359873.webp";